import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { MonogramMark } from "../components/icons";
import { formatDate, readMinutes } from "../components/Blogs";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

const BlogPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined);

  useEffect(() => {
    api.get(`/blogs/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#F8FAF8]">
      <header className="border-b border-[#0D3B3E]/10 bg-[#F8FAF8]/85 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 h-[64px] flex items-center justify-between">
          <Link to="/" data-testid="blog-back-home-link" className="flex items-center gap-3">
            <MonogramMark className="w-8 h-8" />
            <span className="text-[10px] font-mono tracking-[0.2em] text-[#0D9488] hidden sm:block">GENTLE CURE JOURNAL</span>
          </Link>
          <Link
            to="/"
            data-testid="blog-back-button"
            className="inline-flex items-center gap-2 text-[11px] font-mono tracking-[0.18em] text-[#0D3B3E]/70 hover:text-[#0D9488] transition-colors duration-300"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> BACK TO SITE
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
        {post === undefined && (
          <div data-testid="blog-loading" className="space-y-4">
            <div className="h-8 w-2/3 bg-[#0D3B3E]/[0.05] animate-pulse" />
            <div className="h-4 w-full bg-[#0D3B3E]/[0.04] animate-pulse" />
            <div className="h-4 w-5/6 bg-[#0D3B3E]/[0.04] animate-pulse" />
          </div>
        )}

        {post === null && (
          <div data-testid="blog-not-found" className="text-center py-20">
            <p className="font-display font-semibold text-2xl text-[#0D3B3E]">Article not found</p>
            <p className="mt-3 text-sm text-slate-600">It may have been unpublished or moved.</p>
            <Link to="/" className="mt-6 inline-block text-[11px] font-mono tracking-[0.18em] text-[#0D9488] underline underline-offset-4">
              RETURN HOME
            </Link>
          </div>
        )}

        {post && (
          <article data-testid="blog-article">
            <div className="flex flex-wrap items-center gap-3 mb-6">
              <span className="text-[9px] font-mono tracking-[0.2em] text-[#0D9488] border border-[#0D9488]/30 rounded-full px-2.5 py-1">
                {post.tag}
              </span>
              <span className="text-[10px] font-mono tracking-[0.15em] text-slate-500">
                {formatDate(post.created_at)} · {readMinutes(post.content)} MIN READ
              </span>
            </div>
            <h1
              data-testid="blog-article-title"
              className="text-2xl sm:text-3xl lg:text-4xl font-display font-semibold text-[#0D3B3E] tracking-tight leading-tight"
            >
              {post.title}
            </h1>
            <p className="mt-4 text-[10px] font-mono tracking-[0.2em] text-slate-500">
              BY DR. MUGDHA ADHIKARI · MD (HOM), BHMS
            </p>
            {post.cover && (
              <img src={post.cover} alt={post.title} className="mt-8 w-full border border-[#0D3B3E]/10" loading="lazy" />
            )}
            <div className="mt-8 space-y-5">
              {post.content.split(/\n\n+/).map((para, i) => (
                <p key={i} data-testid={`blog-paragraph-${i}`} className="text-base text-slate-700 leading-relaxed">
                  {para}
                </p>
              ))}
            </div>
            <div className="mt-12 pt-6 border-t border-[#0D3B3E]/10">
              <p className="text-[10px] font-mono tracking-[0.2em] text-[#0D9488]">GENTLE CURE HOMOEOCLINIC · KANDIVALI WEST, MUMBAI</p>
            </div>
          </article>
        )}
      </main>
      <FloatingWhatsApp />
    </div>
  );
};

export default BlogPage;
